(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["early-access"] && !Shopify.designMode) return;
  try {
    
  class EarlyAccess {
    constructor(root) {
      this.root = root;
      this.video = root.querySelector('.ea__video');
      this.isVideo = this.video && this.video.tagName === 'VIDEO';
      this.gate = root.querySelector('[data-ea-gate]');
      this.form = root.querySelector('[data-ea-form]');
      this.enter = root.querySelector('[data-ea-enter]');
      this.skip = root.querySelector('[data-ea-skip]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.init();
    }

    init() {
      // Coming back from Shopify's post-submit redirect: straight to the result.
      // Post-submit redirect, or a signed-in visitor without access: show the
      // result at once rather than replaying the teaser.
      if (this.root.querySelector('[data-ea-success], [data-ea-immediate]')) return this.reveal({ focus: false });

      // No video, or the visitor asked for less motion: don't make them wait.
      if (!this.isVideo || this.reduced) {
        if (this.isVideo && this.reduced) this.video.removeAttribute('autoplay');
        return this.reveal({ focus: false });
      }

      this.gate.hidden = false;
      this.enter.addEventListener('click', () => this.play());
      this.video.addEventListener('ended', () => this.reveal({ focus: true }));
      this.video.addEventListener('error', () => this.reveal({ focus: false }));
    }

    play() {
      const v = this.video;
      // Must stay synchronous inside the click for the gesture to authorise sound.
      v.muted = false;
      v.loop = false;
      v.currentTime = 0;
      const p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {
          // Sound refused anyway — carry on muted rather than dead-ending.
          v.muted = true;
          v.play().catch(() => this.reveal({ focus: true }));
        });
      }
      this.gate.hidden = true;
      this.watch();
      this.armSkip();
    }

    // An escape hatch, but not an invitation: it stays out of the opening
    // seconds so the teaser gets a fair run before anyone is offered the door.
    armSkip() {
      if (!this.skip) return;
      // ?? alone would let an empty attribute through as Number('') === 0,
      // showing the button instantly. Fall back on anything non-numeric.
      const raw = Number(this.root.dataset.skipDelay);
      const delay = Math.max(0, (Number.isFinite(raw) ? raw : 5) * 1000);
      this.skipTimer = setTimeout(() => {
        this.skip.hidden = false;
        // Two frames, so the transition runs from the hidden state.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.skip.classList.add('is-visible'));
        });
      }, delay);
      this.skip.addEventListener('click', () => this.reveal({ focus: true }));
    }

    // No skip control, so a stalled download would strand the visitor forever.
    // This fires only on failure: 20s with no playback progress.
    watch() {
      const v = this.video;
      const bump = () => {
        clearTimeout(this.stallTimer);
        this.stallTimer = setTimeout(() => this.reveal({ focus: false }), 20000);
      };
      v.addEventListener('timeupdate', bump);
      v.addEventListener('waiting', bump);
      bump();
    }

    reveal({ focus }) {
      clearTimeout(this.stallTimer);
      clearTimeout(this.skipTimer);
      if (this.skip) {
        this.skip.classList.remove('is-visible');
        this.skip.hidden = true;
      }
      if (this.gate) this.gate.hidden = true;
      this.form.hidden = false;
      if (this.isVideo && !this.video.paused && !this.video.ended) {
        this.video.muted = true;
        this.video.loop = true;
        this.video.play().catch(() => {});
      }
      if (focus) {
        const input = this.form.querySelector('.ea__input');
        if (input) input.focus({ preventScroll: true });
      }
    }
  }

  function initEarlyAccess() {
    document.querySelectorAll('.ea').forEach((el) => {
      if (!el.dataset.eaReady) {
        el.dataset.eaReady = '1';
        new EarlyAccess(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initEarlyAccess);
  document.addEventListener('shopify:section:load', initEarlyAccess);
  if (document.readyState !== 'loading') initEarlyAccess();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
